import styled from 'styled-components';

export const AdviseBannerContainer = styled.div`
    background-color: ${({ theme }) => theme.palette.grayscale.black};
    padding: 1em;
    color: ${({ theme }) => theme.palette.grayscale.white};
    justify-content: center;
    text-align: center;
    font-family: Lato;
    font-size: 1rem;
    font-weight: bold;
`;

export const TermsAndConditionsNotification = styled.p`
    font-size: 0.8rem;
    margin-top: 1rem;
    font-weight: normal;
`;
